import { useRef, useEffect, useState } from 'react';

import { ReactComponent as LeftArrow } from '@assets/icons/crm/leftArrrow.svg';
import { ReactComponent as RightArrow } from '@assets/icons/crm/rightArrow.svg';

import CommonImage from '@/components/CommonImage';
import { Task_PRIORITY_OPTIONS } from '@/features/my-dashborad/utils';
const FactoryDevelopmentList = ({
	listViewResponse,
	onClickDesignImage,
	handleSelectSampleItem,
	handleSelectAllSampleItem,
	selectedSampleItem,
	handleUpdatePriority,
	handleGetRemarks,
	isUpdatingRemarks
}) => {
	const elementRef = useRef(null);
	const [arrowDisable, setArrowDisable] = useState(true);
	const [rightArrowDisable, setRightArrowDisable] = useState(false);

	//arrow buttons
	const updateButtonStates = (element) => {
		if (!element) return;

		const isAtStart = element.scrollLeft === 0;
		const isAtEnd = element.scrollLeft + element.clientWidth >= element.scrollWidth - 1;

		setArrowDisable(isAtStart);
		setRightArrowDisable(isAtEnd);
	};
	const handleHorizontalScroll = (element, speed, distance, step) => {
		if (!element) return;
		let scrollAmount = 0;
		const slideTimer = setInterval(() => {
			element.scrollLeft += step;
			scrollAmount += Math.abs(step);
			if (scrollAmount >= distance) {
				clearInterval(slideTimer);
			}
			// Update button states during scroll
			updateButtonStates(element);
		}, speed);
	};

	useEffect(() => {
		const scrollElement = elementRef.current;
		if (!scrollElement) return undefined;
		updateButtonStates(scrollElement);
		// Keep arrow state in sync with user-driven horizontal scroll.
		const handleScroll = () => updateButtonStates(scrollElement);
		scrollElement.addEventListener('scroll', handleScroll);

		return () => {
			scrollElement.removeEventListener('scroll', handleScroll);
		};
	}, []);

	const PriorityDropdown = ({ priority, productItemData, handleUpdatePriority }) => (
		<div className="option">
			<div className="dropdown">
				<button
					aria-expanded="false"
					className="btn btn-default dropdown-toggle"
					data-toggle="dropdown"
					id="menu1"
					type="button"
				>
					<span
						className={`mr-2 status yellow-1 status-with-border  ${Task_PRIORITY_OPTIONS[priority]}`}
					>
						{priority || 'Select priority'}
					</span>
					<CommonImage
						className="arrow-icon"
						src="/icons/down-arrow-gray-dark-01.svg"
						width={20}
						height={20}
					/>
				</button>
				<ul
					aria-labelledby="menu1"
					className="dropdown-menu dropdown-menu-right shadow-lg"
					role="menu"
					x-placement="bottom-end"
				>
					{Task_PRIORITY_OPTIONS?.map((tag) => (
						<li
							key={tag.value}
							className="px-4 pb-3 pt-3"
							role="presentation"
							onClick={() =>
								handleUpdatePriority({
									...productItemData,
									taskPriority: tag.value
								})
							}
						>
							<span
								className={`font-weight-normal ${tag.className}`}
								role="menuitem"
								tabIndex={-1}
							>
								{tag?.name}
							</span>
						</li>
					))}
				</ul>
			</div>
		</div>
	);

	const renderFactoryDevelopmentListRow = (item, idx) => {
		return (
			<tr key={`${item.id}_${idx}`}>
				<td className="checkbox-column">
					<div className="custom-chekbox">
						<div className="form-group m-0">
							<input
								type="checkbox"
								id={`${item?.id}-${idx}`}
								name={`sample_${item?.id}`}
								value={item?.id}
								onChange={(e) => handleSelectSampleItem(e, item)}
								checked={selectedSampleItem.includes(parseInt(item?.id))}
							/>
							<label htmlFor={`${item?.id}-${idx}`} />
						</div>
					</div>
				</td>
				<td className="image-column cursor-pointer" onClick={() => onClickDesignImage(item?.id)}>
					<div className="d-flex align-items-center justify-content-center">
						<img src={item.designDocuments?.[0]?.docUrl} alt="" className="cell-img pr-2" />
					</div>
				</td>
				<td className="ref-column">
					<p className="regular-14 gray_dark_02 mb-0">{item?.systemReferenceNumber}</p>
				</td>
				<td className="brand-column">
					<p className="regular-14 gray_dark_02 mb-0">
						{item?.factoryDevelopmentJourneyDetails?.brandResponse?.name}
					</p>
				</td>
				<td className="request-column">
					<p className="regular-14 gray_dark_02 mb-0">
						{item?.factoryDevelopmentJourneyDetails?.requestName}
					</p>
				</td>
				<td className="style-details-column">
					<p className="regular-14  gray_dark_02 mb-0">{item?.productGroup}</p>
					<p className="regular-14  gray_dark_02 mb-0">{item?.mainFabricType}</p>
					<p className="regular-14  gray_dark_02 mb-0">{item?.addedByName}</p>
				</td>
				<td className="development-type-column">
					<p className="regular-14 gray_dark_02 mb-0">
						{item?.factoryDevelopmentJourneyDetails?.sampleDevelopmentType}
					</p>
				</td>
				<td className="color-size-qty-column">
					<p className="regular-14 gray_dark_02 mb-0">
						color:
						{item?.factoryDevelopmentJourneyDetails?.sampleItemDetailsList
							.map((item) => item?.colorResponse)
							.join(', ')}
					</p>
					<p className="regular-14 gray_dark_02 mb-0">
						Size:
						{item?.factoryDevelopmentJourneyDetails?.sampleItemDetailsList
							.map((item) => item?.size)
							.join(', ')}
					</p>
					<p className="regular-14 gray_dark_02 mb-0">
						Qty:
						{item?.factoryDevelopmentJourneyDetails?.sampleItemDetailsList
							.map((item) => item?.quantity)
							.join(', ')}
					</p>
				</td>
				<td className="fabric-details-column">
					<p className="regular-14 gray_dark_02 mb-0">{item?.fabricDetails}</p>
				</td>
				<td className="print-embo-wash-column">
					<p className="regular-14 gray_dark_02 mb-0">
						<span className="regular-14 gray_dark_02 mb-0 d-block">
							{item?.factoryDevelopmentJourneyDetails?.printTypes?.join(', ')}
						</span>

						<span className="regular-14 gray_dark_02 mb-0 d-block">
							{item?.factoryDevelopmentJourneyDetails?.emboTypes?.join(', ')}
						</span>

						<span className="regular-14 gray_dark_02 mb-0 d-block">
							{item?.factoryDevelopmentJourneyDetails?.washTypes?.join(', ')}
						</span>
					</p>
				</td>
				<td className="planned-vs-actual-column">
					<p className="regular-14 gray_dark_02 mb-0">
						Required: {item?.factoryDevelopmentJourneyDetails?.requiredDate}
					</p>
					<p className="regular-14 gray_dark_02 mb-0">
						Planned: {item?.factoryDevelopmentJourneyDetails?.plannedDate}
					</p>
					<p className="regular-14 gray_dark_02 mb-0">
						Actual H/O: {item?.factoryDevelopmentJourneyDetails?.actualHandoverDate}
					</p>
				</td>
				<td className="request-rev-column">
					<p className="regular-14 gray_dark_02 mb-0">
						H/O to project team: {item?.factoryDevelopmentJourneyDetails?.handoverToProjectDate},
						{item?.factoryDevelopmentJourneyDetails?.handoverToProjectName}
					</p>
					<p className="regular-14 gray_dark_02 mb-0">
						Received:{item?.factoryDevelopmentJourneyDetails?.projectReceivedDate},
						{item?.factoryDevelopmentJourneyDetails?.projectReceivedByName}
					</p>
					<p className="regular-14 gray_dark_02 mb-0">
						GT review: {item?.factoryDevelopmentJourneyDetails?.gtReviewDate},
						{item?.factoryDevelopmentJourneyDetails?.factoryName}
					</p>
				</td>
				<td className="factory-ho-rev-column">
					<p className="regular-14 gray_dark_02 mb-0">
						Factory:{item?.factoryDevelopmentJourneyDetails?.factoryName},{' '}
					</p>
					<p className="regular-14 gray_dark_02 mb-0">
						Send: {item?.factoryDevelopmentJourneyDetails?.handoverToFactoryDate},{' '}
						{item?.factoryDevelopmentJourneyDetails?.lastStatusByName}
					</p>
					<p className="regular-14 gray_dark_02 mb-0">
						Received: {item?.factoryDevelopmentJourneyDetails?.receiveFromFactoryDate},
						{item?.factoryDevelopmentJourneyDetails?.receiveFromFactoryByName}
					</p>
				</td>
				<td className="review-ho-to-am-column">
					<p className="regular-14 gray_dark_02 mb-0">
						Partial Dev:{item?.factoryDevelopmentJourneyDetails?.partialDevDate},
						{item?.factoryDevelopmentJourneyDetails?.partialDevByName}
					</p>
					<p className="regular-14 gray_dark_02 mb-0">
						GT sample review:{item?.factoryDevelopmentJourneyDetails?.gtSampleReviewDate},
						{item?.factoryDevelopmentJourneyDetails?.gtSampleReviewByName}
					</p>
					<p className="regular-14 gray_dark_02 mb-0">
						H/O to AM: {item?.factoryDevelopmentJourneyDetails?.actualHandoverDate}
					</p>
				</td>
				<td className="buyer-review-column">
					<p className="regular-14 gray_dark_02 mb-0">
						Send to buyer: {item?.factoryDevelopmentJourneyDetails?.sendToBuyerDate},
						{item?.factoryDevelopmentJourneyDetails?.sendToBuyerByName}
					</p>
					<p className="regular-14 gray_dark_02 mb-0">
						Buyer review: {item?.factoryDevelopmentJourneyDetails?.buyerReviewDate},
						{item?.factoryDevelopmentJourneyDetails?.buyerReviewByName}
					</p>
				</td>
				<td className="buyer-review-status-column">
					<p className="regular-14 gray_dark_02 mb-0">
						Order expected:{item?.factoryDevelopmentJourneyDetails?.orderExpectedDate},
						{item?.factoryDevelopmentJourneyDetails?.orderExpectedUpdatedByName}
					</p>
					<p className="regular-14 gray_dark_02 mb-0">Development closed with order:12/12/1/2</p>
				</td>
				<td className="actual-lead-time-column">
					<p className="regular-14 gray_dark_02 mb-0">
						{item?.factoryDevelopmentJourneyDetails?.actualLeadTime}d
					</p>
				</td>
				<td className="plan-lead-time-column">
					<p className="regular-14 gray_dark_02 mb-0">
						{item?.factoryDevelopmentJourneyDetails?.plannedLeadTime}d
					</p>
				</td>
				<td className="required-lead-time-column">
					<p className="regular-14 gray_dark_02 mb-0">
						{item?.factoryDevelopmentJourneyDetails?.requiredLeadTime}d
					</p>
				</td>
				<td className="last-status-column">
					<div>
						<span className="status yellow-1 status-with-border d-inline-block mb-1">
							{item?.factoryDevelopmentJourneyDetails?.lastStatusName}
						</span>
						<p className="regular-14 gray_dark_02 mb-0">
							{item?.factoryDevelopmentJourneyDetails?.lastStatusDate}
						</p>
						<p className="regular-14 gray_dark_02 mb-0">
							by {item?.factoryDevelopmentJourneyDetails?.lastStatusByName}
						</p>
					</div>
				</td>
				<td className="pending-issue-column">
					<p className="regular-14 gray_dark_02 mb-0">
						{item?.factoryDevelopmentJourneyDetails?.pendingIssueCount}
					</p>
				</td>
				<td className="priority-column">
					<PriorityDropdown
						priority={item?.factoryDevelopmentJourneyDetails?.taskPriority}
						productItemData={item}
						handleUpdatePriority={handleUpdatePriority}
					/>
				</td>
				<td className="remarks-column text-field-column">
					<input
						type="text"
						className="regular-14 gray_dark_02 mb-0"
						placeholder="Remarks"
						defaultValue={item?.factoryDevelopmentJourneyDetails?.remarks ?? ''}
						onBlur={(e) => handleGetRemarks(item, e.target.value)}
						onKeyDown={(e) => {
							if (e.key === 'Enter') e.currentTarget.blur();
						}}
						disabled={isUpdatingRemarks}
					/>
				</td>
			</tr>
		);
	};

	return (
		<div>
			<div className="single-table position-relative mt-4 mb-4">
				<div className="factory-development-details-view-table scroll-x-label" ref={elementRef}>
					<table className="table with-border">
						<thead>
							<tr>
								<th>
									<div className="custom-chekbox">
										<div className="form-group m-0">
											<input
												type="checkbox"
												id="selectAll"
												name="selectAll"
												onChange={(e) => handleSelectAllSampleItem(e)}
												checked={listViewResponse?.data?.every((item) =>
													selectedSampleItem.includes(parseInt(item?.id))
												)}
											/>
											<label htmlFor="selectAll" />
										</div>
									</div>
								</th>
								<th>Image</th>
								<th>Ref</th>
								<th>Brand</th>
								<th>Request</th>
								<th className="white-space-nowrap">Style details</th>
								<th className="white-space-nowrap">Development type</th>
								<th className="white-space-nowrap">Color -Size -Qty</th>
								<th className="white-space-nowrap">Fabric details</th>
								<th className="white-space-nowrap">Print, Embo, Wash</th>
								<th className="white-space-nowrap">Planned vs Actual</th>
								<th className="white-space-nowrap">Request &amp; Rev</th>
								<th className="white-space-nowrap">Factory H/O &amp; Rev</th>
								<th className="white-space-nowrap">Review &amp; H/O to AM</th>
								<th className="white-space-nowrap">Buyer review</th>
								<th className="white-space-nowrap">Buyer review status</th>
								<th>
									<span className="white-space-nowrap">Actual lead time:</span>
									<span className="white-space-wrap">H/O to project &gt; H/O to Owner</span>
								</th>
								<th>
									<span className="white-space-nowrap">Plan lead time:</span>
									<span className="white-space-wrap">H/O to project &gt; Plan date</span>
								</th>
								<th>
									<span className="white-space-nowrap">Required lead time:</span>
									<span className="white-space-wrap">H/O to project &gt; Required</span>
								</th>
								<th className="white-space-nowrap">Last status</th>
								<th className="white-space-nowrap">Pending issue</th>
								<th>Priority</th>
								<th>Remarks</th>
							</tr>
						</thead>
						<tbody>
							{listViewResponse?.map((item, idx) => renderFactoryDevelopmentListRow(item, idx))}
						</tbody>
					</table>
				</div>
			</div>
			<div className="scroll-table-buttons sample-journey-table-button">
				<button
					className="left"
					disabled={arrowDisable}
					onClick={() => handleHorizontalScroll(elementRef.current, 25, 100, -400)}
				>
					<LeftArrow />
				</button>
				&nbsp;&nbsp;
				<button
					className="right"
					disabled={rightArrowDisable}
					onClick={() => handleHorizontalScroll(elementRef.current, 25, 100, 400)}
				>
					<RightArrow />
				</button>
			</div>
		</div>
	);
};

export default FactoryDevelopmentList;
